import React from "react";
import { t } from "ttag";

import {
    IAddon,
    IConcreteBundle,
    IProduct,
} from "../../../models/catalogue.interfaces";
import { IProductID } from "../../../models/nominals";
import { getUpgradeID } from "../../configurator/selectors";

interface IProps {
    product: IProduct;
    selectedUpgrades: IAddon[];
    isSelected: boolean;
    pageRootProduct: IProductID | null;
    onSelectionChange: (
        updates: Array<{ productID: IProductID; quantity: number }>,
    ) => void;
    upgradeBundles: IConcreteBundle[];
}

export const ProductCompareUpgradeTile = ({
    product,
    selectedUpgrades,
    isSelected,
    pageRootProduct,
    onSelectionChange,
    upgradeBundles,
}: IProps): React.ReactNode => {
    const onButtonClick = (
        product: IProduct,
        event: React.MouseEvent<HTMLButtonElement>,
    ) => {
        event.preventDefault();
        const upgradeID = getUpgradeID(product);

        // Select / deselect this product
        const updates = [
            {
                productID: upgradeID,
                quantity: selectedUpgrades.length > 0 ? 0 : 1,
            },
        ];

        // Send change batch
        onSelectionChange(updates);
    };

    const buildUpgradeButton = (bundle: IConcreteBundle) => {
        return bundle.suggested_products.map((product) => {
            const buttonText = isSelected ? t`Remove Upgrade` : t`Add Upgrade`;
            return (
                <button
                    key={`${bundle.id}-${product.id}`}
                    onClick={(event) => onButtonClick(product, event)}
                >
                    {buttonText}
                </button>
            );
        });
    };

    const isRootProduct = product.id === pageRootProduct;
    if (!isRootProduct) {
        return null;
    }
    return (
        <>
            {upgradeBundles.map((bundle) => (
                <React.Fragment key={bundle.id}>
                    {buildUpgradeButton(bundle)}
                </React.Fragment>
            ))}
        </>
    );
};
